import type {ReactAction} from '@netx/core/bootstrap';
import {faSlidersH} from '@fortawesome/pro-solid-svg-icons';
import {actionsToOrderedActions} from '@netx/core-next/utils/actions';
import {canManageUserSettings} from '../enablers';
import {UserActionLabel} from '../locales';
import {userActionAttributeSets} from './user-attribute-sets';
import {userActionNotifications} from './user-notifications';
import {userIntegrationsActionRoute} from '@netx/core-user-integrations/actions/user-integrations-route';

export const userActionSettingsIcon = faSlidersH;

/**
 * Route to user settings
 * @param params
 * @returns Action
 */
export const userActionSettings = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-settings',
	cb: () => {},
	enableTest: () => canManageUserSettings(),
	icon: userActionSettingsIcon,
	get label() {
		return UserActionLabel.SETTINGS;
	},
	...params,
	children: actionsToOrderedActions([
		userActionAttributeSets(),
		userIntegrationsActionRoute(),
		userActionNotifications(),
	]),
});

export default userActionSettings;
